/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/DashboardPageBlockCartesianSerieGrouping', 'model/DashboardPageBlockCartesianSerieMilestone'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./DashboardPageBlockCartesianSerieGrouping'), require('./DashboardPageBlockCartesianSerieMilestone'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockCartesianSerieReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.DashboardPageBlockCartesianSerieGrouping, root.ForStractionServiceApi.DashboardPageBlockCartesianSerieMilestone);
  }
}(this, function(ApiClient, CorporateStructureLink, DashboardPageBlockCartesianSerieGrouping, DashboardPageBlockCartesianSerieMilestone) {
  'use strict';




  /**
   * The DashboardPageBlockCartesianSerieReport model module.
   * @module model/DashboardPageBlockCartesianSerieReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockCartesianSerieReport</code>.
   * @alias module:model/DashboardPageBlockCartesianSerieReport
   * @class
   */
  var exports = function() {
    var _this = this;

























  };

  /**
   * Constructs a <code>DashboardPageBlockCartesianSerieReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockCartesianSerieReport} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockCartesianSerieReport} The populated <code>DashboardPageBlockCartesianSerieReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Groupings')) {
        obj['Groupings'] = ApiClient.convertToType(data['Groupings'], [DashboardPageBlockCartesianSerieGrouping]);
      }
      if (data.hasOwnProperty('Milestones')) {
        obj['Milestones'] = ApiClient.convertToType(data['Milestones'], [DashboardPageBlockCartesianSerieMilestone]);
      }
      if (data.hasOwnProperty('GraphTypeID')) {
        obj['GraphTypeID'] = ApiClient.convertToType(data['GraphTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('MainColors')) {
        obj['MainColors'] = ApiClient.convertToType(data['MainColors'], ['String']);
      }
      if (data.hasOwnProperty('ComparisonColors')) {
        obj['ComparisonColors'] = ApiClient.convertToType(data['ComparisonColors'], ['String']);
      }
      if (data.hasOwnProperty('LabelsVisible')) {
        obj['LabelsVisible'] = ApiClient.convertToType(data['LabelsVisible'], 'Boolean');
      }
      if (data.hasOwnProperty('UseTrendLineAsAlternativeDimension')) {
        obj['UseTrendLineAsAlternativeDimension'] = ApiClient.convertToType(data['UseTrendLineAsAlternativeDimension'], 'Boolean');
      }
      if (data.hasOwnProperty('SplitByTrackingLevelID')) {
        obj['SplitByTrackingLevelID'] = ApiClient.convertToType(data['SplitByTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('EmptyItemsHidden')) {
        obj['EmptyItemsHidden'] = ApiClient.convertToType(data['EmptyItemsHidden'], 'Boolean');
      }
      if (data.hasOwnProperty('AxisID')) {
        obj['AxisID'] = ApiClient.convertToType(data['AxisID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingTargetSystemRegisterID')) {
        obj['TrackingTargetSystemRegisterID'] = ApiClient.convertToType(data['TrackingTargetSystemRegisterID'], 'Integer');
      }
      if (data.hasOwnProperty('PastDimensionID')) {
        obj['PastDimensionID'] = ApiClient.convertToType(data['PastDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('AlternativePastDimensionID')) {
        obj['AlternativePastDimensionID'] = ApiClient.convertToType(data['AlternativePastDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('FutureDimensionID')) {
        obj['FutureDimensionID'] = ApiClient.convertToType(data['FutureDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('AlternativeFutureDimensionID')) {
        obj['AlternativeFutureDimensionID'] = ApiClient.convertToType(data['AlternativeFutureDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('PointCalculationID')) {
        obj['PointCalculationID'] = ApiClient.convertToType(data['PointCalculationID'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonTargetID')) {
        obj['ComparisonTargetID'] = ApiClient.convertToType(data['ComparisonTargetID'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonCalculationID')) {
        obj['ComparisonCalculationID'] = ApiClient.convertToType(data['ComparisonCalculationID'], 'Integer');
      }
      if (data.hasOwnProperty('ComparisonTargetIndicatorID')) {
        obj['ComparisonTargetIndicatorID'] = ApiClient.convertToType(data['ComparisonTargetIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('BlockID')) {
        obj['BlockID'] = ApiClient.convertToType(data['BlockID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/DashboardPageBlockCartesianSerieGrouping>} Groupings
   */
  exports.prototype['Groupings'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockCartesianSerieMilestone>} Milestones
   */
  exports.prototype['Milestones'] = undefined;
  /**
   * @member {Integer} GraphTypeID
   * @default 0
   */
  exports.prototype['GraphTypeID'] = 0;
  /**
   * @member {Array.<String>} MainColors
   */
  exports.prototype['MainColors'] = undefined;
  /**
   * @member {Array.<String>} ComparisonColors
   */
  exports.prototype['ComparisonColors'] = undefined;
  /**
   * @member {Boolean} LabelsVisible
   * @default false
   */
  exports.prototype['LabelsVisible'] = false;
  /**
   * @member {Boolean} UseTrendLineAsAlternativeDimension
   * @default false
   */
  exports.prototype['UseTrendLineAsAlternativeDimension'] = false;
  /**
   * @member {Integer} SplitByTrackingLevelID
   */
  exports.prototype['SplitByTrackingLevelID'] = undefined;
  /**
   * @member {Boolean} EmptyItemsHidden
   * @default false
   */
  exports.prototype['EmptyItemsHidden'] = false;
  /**
   * @member {Integer} AxisID
   * @default 0
   */
  exports.prototype['AxisID'] = 0;
  /**
   * @member {Integer} TrackingTargetSystemRegisterID
   */
  exports.prototype['TrackingTargetSystemRegisterID'] = undefined;
  /**
   * @member {Integer} PastDimensionID
   * @default 0
   */
  exports.prototype['PastDimensionID'] = 0;
  /**
   * @member {Integer} AlternativePastDimensionID
   */
  exports.prototype['AlternativePastDimensionID'] = undefined;
  /**
   * @member {Integer} FutureDimensionID
   * @default 0
   */
  exports.prototype['FutureDimensionID'] = 0;
  /**
   * @member {Integer} AlternativeFutureDimensionID
   */
  exports.prototype['AlternativeFutureDimensionID'] = undefined;
  /**
   * @member {Integer} PointCalculationID
   * @default 0
   */
  exports.prototype['PointCalculationID'] = 0;
  /**
   * @member {Integer} ComparisonTargetID
   */
  exports.prototype['ComparisonTargetID'] = undefined;
  /**
   * @member {Integer} ComparisonCalculationID
   */
  exports.prototype['ComparisonCalculationID'] = undefined;
  /**
   * @member {Integer} ComparisonTargetIndicatorID
   */
  exports.prototype['ComparisonTargetIndicatorID'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Integer} BlockID
   * @default 0
   */
  exports.prototype['BlockID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


